<template>
  <div class="stack-container">
    <el-card class="stack-card" :body-style="{ padding: '0px' }">
      <div class="stack-card-left">
        <div class="stack-card-left-header">
          <div
            class="stack-card-left-header-title"
            :class="{ activeTab: $route.query.id === 0 }"
          >
            <!-- <h4>{{$t('content.books.allBook')}}</h4>
                        <span>1000</span> -->
            <h4>{{ $t('content.books.classify') }}</h4>
          </div>
        </div>
        <div class="stack-sideBar-node" v-bar>
          <div class="stack-sideBar-node-wrap">
            <ul
              class="stack-sideBar-tree"
              v-for="(node, index) in categories"
              :key="index"
            >
              <tree-view
                :node="node"
                :index="index"
                :depth="0"
                @addChildNode="addChildNode"
                @editorNode="editorNode"
                @delNode="delNode"
                @treeNodeClick="treeNodeClick"
                @dragstart="dragstart"
                @drop="drop"
              />
            </ul>
          </div>
        </div>
        <div class="stack-sideBar-tree-btn">
          <button class="global-button-style" @click="addRootNode">
            <i class="el-icon-plus"></i>
          </button>
        </div>
      </div>
      <div class="stack-card-right">
        <div class="isSearch" v-if="isSearch">
          <div style="display: none">
            <div class="demo-input-suffix">
              <div class="typeCtl">{{ $t('content.books.name') }}：</div>
              <el-input
                @clear="$emit('clearSearch')"
                @keyup.enter.native="search"
                :placeholder="$t('placeholder.checkKey')"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search search-icon"
                  @click.stop="search"
                ></i>
              </el-input>
            </div>
            <div class="demo-input-suffix">
              <div class="typeCtl">{{ $t('content.books.classify') }}：</div>
              <el-select
                v-model="value"
                filterable
                :placeholder="$t('placeholder.select')"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="demo-input-suffix">
              <div class="typeCtlTest">{{ $t('content.books.readers') }}：</div>
              <el-select
                v-model="value"
                filterable
                :placeholder="$t('placeholder.select')"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="demo-input-suffix">
              <div class="typeCtl">{{ $t('commonMsg.status') }}：</div>
              <el-select
                v-model="value"
                filterable
                :placeholder="$t('placeholder.select')"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="demo-input-suffix">
              <button class="global-button-style testCtl">
                {{ $t('commonMsg.search') }}
              </button>
            </div>
          </div>

          <div class="searchScl">
            <div class="searchSclLeft">
              <list-search
                ref="listSearch"
                @listSearchEvn="listSearchEvn"
                @clearSearch="clearSearch"
              />
            </div>
            <div class="searchSclRight">
              <button class="global-button-style" @click.stop="batchAdd">
                {{ $t('content.books.addToGroup') }}
              </button>
              <button class="global-button-style" @click="recover">
                {{ $t('commonMsg.back') }}
              </button>
            </div>
          </div>
        </div>
        <div class="stack-card-main">
          <bookStackHeader
            :bookInfo="bookInfo"
            :sourceType="sourceType"
            :selectCtrl="isSelect"
            :selectDatas="selectDatas"
            @editBookStack="editBookStack"
            @manageBook="manageBook"
            @batchUpload="batchUpload"
            v-if="!isSearch"
          />
          <div class="stack-mgt-handle">
            <p>
              {{ $t('content.books.records') }}：{{
                bookInfo ? bookInfo.booksTotal : 0
              }}
            </p>
            <div class="stack-mgt-search" v-if="!isSearch">
              <i v-if="!isSelect" @click="model = !model">
                <img src="@/assets/img/table.png" alt="" v-show="!model" />
                <img
                  src="@/assets/img/unorderedList.png"
                  alt=""
                  v-show="model"
                />
              </i>
              <list-search
                ref="listSearch"
                @listSearchEvn="listSearchEvn"
                @clearSearch="clearSearch"
              />
            </div>
          </div>
          <div v-if="isSelect" class="stack-mgt-batchBtn">
            <button class="global-button-style" @click.stop="batchAdd">
              {{ $t('content.books.addToGroup') }}
            </button>
            <template v-if="sourceType !== 4">
              <button class="global-button-style" @click.stop="moveBook">
                {{ $t('content.books.moveClassify') }}
              </button>
              <button
                class="global-button-style"
                @click.stop="setPriceForBooks"
              >
                {{ $t('content.books.setPrice') }}
              </button>
              <button
                class="global-button-style"
                @click.stop="setStatusForBooks(1)"
              >
                {{ $t('content.books.soldOn') }}
              </button>
              <button
                class="global-button-style"
                @click.stop="setStatusForBooks(0)"
              >
                {{ $t('content.books.soldOut') }}
              </button>
              <button class="global-button-style" @click.stop="oddBook">
                {{ $t('commonMsg.del') }}
              </button>
            </template>
            <button class="global-button-style" @click="cancel">
              {{ $t('commonMsg.cancel') }}
            </button>
          </div>
          <div class="stack-card-item" v-if="model">
            <div class="stack-card-sort">
              <div class="sort-item">
                <span
                  v-for="(target, id) in tagList"
                  :key="id"
                  @click="choseprofrom(id)"
                  :class="{ secectBackground: flag == id }"
                >
                  {{ target.name }}
                </span>
              </div>
              <div class="sort-item">
                <el-checkbox
                  v-if="isSelect"
                  v-model="allCheck"
                  :label="$t('commonMsg.checkAll')"
                  @change="checkAll"
                ></el-checkbox>
                <span
                  >{{ $t('content.books.online') }}（{{
                    bookInfo ? bookInfo.booksTotal : 0
                  }}）</span
                >
                <span>{{ $t('content.books.notOnline') }}（0）</span>
              </div>
            </div>
            <BookItem
              component="stack"
              :booksData="booksData"
              :selectCtrl="isSelect"
              @checkBookDetail="checkBookDetail"
              @selectEvn="selectEvn"
              @editBook="editBook"
            />
          </div>
          <div class="stack-card-item" v-else>
            <BooksTable
              ref="BooksTable"
              :tableData="booksData"
              :tableProps="tableProps"
              :isSelectOverall="isSelectOverall"
              :isHandle="isHandle"
              @tableHandle="tableHandle"
              @ediTableHandle="ediTableHandle"
              @filterEvn="filterEvn"
              @selectEvnTable="selectEvnTable"
            />
          </div>
        </div>
        <pagination
          :pageSize="params.limit"
          :total="total"
          @pageNum="getPageNum"
        />
      </div>
    </el-card>
    <transition-group name="fade">
      <addComponent
        key="addComponent"
        v-if="addPopup"
        :title="addPopupTitle"
        :ruleForm="ruleForm"
        :ruleProps="ruleProps"
        :rules="rules"
        @addEvn="addEvn"
      />
      <addChannelPopup
        key="addChannelPopup"
        v-if="addChannelPopup"
        :title="addPopupTitle"
        :ruleForm="ruleForm"
        :ruleProps="ruleProps"
        :rules="rules"
        @addEditEvn="addEditEvn"
      />
      <delPopup key="delPopup" v-if="delPopup" @deleteHandle="deleteHandle" />
      <addComponentImg
        key="addPopupImg"
        v-if="addPopupImg"
        :title="addPopupTitle"
        :ruleForm="ruleForm"
        :ruleProps="ruleProps"
        :rules="rules"
        @addEvnImg="addEvnImg"
      />
      <classifyEdit
        key="classifyEdit"
        v-if="showClassifyEdit"
        :bookInfo="bookInfo"
        :title="addPopupTitle"
        :ruleForm="ruleForm"
        :ruleProps="ruleProps"
        :rules="rules"
        @editModules="editModules"
      />

      <!-- 添加到书单/移动分类公用 -->
      <addBookList
        key="addBookList"
        :title="bookListTitle"
        :channles="listData"
        @confirmEvn="confirmEvn"
        v-if="showAddBookList"
      />
      <batchUpload key="batchUpload" v-if="showBatchUpload" />
    </transition-group>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import allBooks from '../components/allBooks'
import treeView from '../components/treeView'
import addComponent from '@/components/addPopup'
import addComponentImg from '@/components/addPopupImg'
import addChannelPopup from '@/components/addChannelPopup'
import delPopup from '@/components/delPopup'
import bookStackHeader from '../components/bookStackHeader'
import BooksTable from '../components/booksTable'
import BookItem from '../components/bookItem'
import listSearch from '@/components/listSearch'
import pagination from '@/components/pagination'
import classifyEdit from '../components/classifyEdit'
import addBookList from '@/components/addBookList'
import batchUpload from '@/components/batchUpload'
export default {
  computed: {
    ...mapGetters([
      'categories',
      'addPopup',
      'addPopupImg',
      'addChannelPopup',
      'showBatchUpload',
      'showClassifyEdit',
      'showAddBookList',
      'delPopup'
    ]),
    ruleProps() {
      let ruleProps = [
        {
          prop: 'name',
          label: this.$t('content.books.stackName'),
          placeholder: this.$t('placeholder.name')
        }
      ]
      return ruleProps
    },
    rules() {
      let rules = {
        name: [
          {
            required: true,
            message: this.$t('verify.groupName'),
            trigger: 'blur'
          }
        ]
      }
      return rules
    },
    tableProps() {
      let tableProps = [
        {
          prop: 'cover',
          label: this.$t('content.books.cover')
        },
        {
          prop: 'name',
          label: this.$t('content.books.bookName')
        },
        {
          prop: 'views',
          label: this.$t('content.books.views')
        },
        {
          prop: 'sales',
          label: this.$t('content.books.sales')
        },
        {
          prop: 'rate',
          label: this.$t('content.books.readers')
        },
        {
          prop: 'price',
          label: this.$t('content.books.price')
        },
        {
          prop: 'updated_at',
          label: this.$t('commonMsg.updatedAt')
        },
        {
          prop: 'status',
          label: this.$t('content.books.status')
        },
        {
          prop: 'handle',
          label: this.$t('commonMsg.handle'),
          width: 120,
          btn: [this.$t('commonMsg.check'), this.$t('commonMsg.edit')]
        }
      ]
      return tableProps
    }
  },
  components: {
    allBooks,
    treeView,
    addComponent,
    delPopup,
    addComponentImg,
    addChannelPopup,
    bookStackHeader,
    BooksTable,
    BookItem,
    listSearch,
    pagination,
    classifyEdit,
    addBookList,
    batchUpload
  },
  data() {
    return {
      treeItem: null,
      searchVal: {
        name: '',
        rate: null,
        status: null
      },
      params: {
        limit: 40,
        offset: 0
        // sortBy:'id'
      },
      ruleForm: {
        name: '',
        image_url: ''
      },
      sourceType: Number(this.$route.query.sourceType) || 0,
      total: 0,
      delType: '',
      bookInfo: {},
      booksData: [],
      select: false,
      isSelect: false,
      allCheck: false,
      model: false,
      addPopupTitle: '',
      bookArr: [],
      bookArrId: [],
      bookListTitle: '',
      listData: [],
      selectDatas: [],
      tagList: [
        { name: this.$t('content.books.all'), id: 1 },
        { name: this.$t('content.books.top'), id: 2 },
        { name: this.$t('content.books.new'), id: 3 },
        { name: this.$t('content.books.price'), id: 4 },
        { name: this.$t('content.books.score'), id: 5 }
      ],
      flag: 0,
      isHandle: this.$store.state.isHandle || ' ',
      options: [
        {
          value: '选项1',
          label: '黄金糕'
        },
        {
          value: '选项2',
          label: '双皮奶'
        }
      ],
      value: '',
      isSearch: this.$store.state.selectShow || false,
      isSelectOverall: this.$store.state.isSelectOverall || false
    }
  },
  methods: {
    getBookCategories() {
      this.$store.dispatch('getBookCategories')
    },
    addEditEvn(data) {
      data.id = this.editorId
      this.editModuleBooks(data)
    },
    addEvn(data) {
      this.createModuleBooks(data)
    },
    createModuleBooks(data) {
      if (this.treeItem) {
        data.id = this.treeItem.id
      }
      this.$http.createCategories(data).then((res) => {
        this.elMsg(this.$t('alertMsg.addSuccess'), 'success')
        this.$store.commit('windowHandle')
        this.getBookCategories()
      })
    },
    editModuleBooks(data) {
      this.$http.editBooks(this.editorId, data).then(async (res) => {
        // await this.getBookChannels();
        this.elMsg(this.$t('alertMsg.modifySuccess'), 'success')
        this.getBookCategories()
        this.getCategoriesDetail()
      })
    },
    delCategories() {
      this.$http
        .delCategories(this.treeItem.id)
        .then(async (res) => {
          this.elMsg(this.$t('alertMsg.delSuccess'), 'success')
          await this.getBookCategories()
          this.$router.push({
            path: this.$route.fullPath,
            query: {
              id: this.categories[0].id,
              sourceType: this.categories[0].source_type
            }
          })
          this.sourceType = this.categories[0].source_type
        })
        .catch((err) => {
          //                    this.elMsg('删除失败', 'error')
        })
    },
    deleteHandle() {
      if (this.delType === 'treeNode') {
        this.delCategories()
      } else if (this.delType === 'book') {
        this.deleteBook()
      }
    },
    // ====================== stack-sideBar 方法回调 ========================
    treeNodeClick(item) {
      if (!item.parent_id) return
      this.sourceType = item.source_type
      delete this.params.text
      this.cancel()
      this.treeItem = item
      this.$router.push({
        name: 'bookstack',
        query: {
          ...this.$route.query,
          id: item.id,
          sourceType: item.source_type
        }
      })
    },
    addChildNode(item) {
      this.treeItem = item
      this.addPopupTitle = this.$t('content.books.addClassify')
      this.$store.commit('windowHandle', 'addPopupImg')
    },
    addEvnImg(data) {
      if (this.treeItem) {
        data.id = this.treeItem.id
      }
      this.$http
        .createCategories(data)
        .then((res) => {
          this.elMsg(this.$t('alertMsg.addSuccess'), 'success')
          this.getBookCategories()
          this.$store.commit('windowHandle')
        })
        .catch((err) => {
          this.elMsg(this.$t('alertMsg.addFailure'), 'error')
          this.$store.commit('windowHandle')
        })
    },
    editorNode(item) {
      this.editorId = item.id
      this.addPopupTitle = this.$t('content.books.editClassify')
      this.$store.commit('windowHandle', 'addChannelPopup')
    },
    delNode(item) {
      this.delType = 'treeNode'
      this.treeItem = item
      this.$store.commit('windowHandle', 'delPopup')
    },
    addRootNode() {
      this.treeItem = null
      this.addPopupTitle = this.$t('content.books.addClassify')
      this.$store.commit('windowHandle', 'addPopup')
    },

    dragstart(node) {
      this.dragType = node.type === 1 ? 'parent' : 'children'
      this.dragItem = node
    },
    async drop(node) {
      let tempArr = null
      if (this.dragType === 'children') {
        if (
          !this.dragItem.parent_id ||
          !node.parent_id ||
          this.dragItem.parent_id !== node.parent_id
        )
          return this.elMsg(this.$t('alertMsg.sortErr2'), 'warning')
        // for (let item of this.channels) {
        //     if (item.id === node.parent_id) {
        //         tempArr = item.children.splice(item.children.indexOf(this.dragItem), 1)
        //         if (this.dragItem.ordinal >= node.ordinal) {
        //             item.children.splice(item.children.indexOf(node), 0, ...tempArr)
        //         } else {
        //             item.children.splice(item.children.indexOf(node) + 1, 0, ...tempArr)
        //         }
        //         tempArr = item.children
        //     }
        // }
      } else {
        if (this.dragItem.parent_id || node.parent_id)
          return this.elMsg(this.$t('alertMsg.sortErr2'), 'warning')
      }
      tempArr = {
        id1: this.dragItem.id,
        ordinal1: this.dragItem.ordinal,
        id2: node.id,
        ordinal2: node.ordinal
      }
      try {
        // await this.$http.bookListOrder(tempArr)
        await this.$http.bookCategoriesOrder(tempArr)
        this.getBookCategories()
      } catch (err) {
        this.elMsg(this.$t('alertMsg.sortFailure'), 'error')
      }
    },
    cancel() {
      this.isSelect = false
      this.isSelectOverall = this.$store.state.isSelectOverall
      this.isHandle = ' '
      this.emptyPitch()
      this.$refs.BooksTable ? this.$refs.BooksTable.toggleSelection() : ''
    },
    recover() {
      this.$router.push({
        path: this.$route.query.from,
        query: { name: 'list' }
      })
      this.$store.dispatch('setSelectShow', false)
      this.$store.dispatch('setOverallShow', false)
      this.$store.dispatch('setHandleShow', ' ')
    },
    getCategoriesDetail() {
      if (!this.$route.query.id) return
      this.$http
        .getCategoriesDetail(this.$route.query.id, this.params)
        .then((res) => {
          for (let item of res.data.books) {
            item.checked = false
          }
          this.booksData = res.data.books
          this.total = res.data.booksTotal
          this.bookInfo = res.data
        })
    },
    getBookCategories() {
      this.$store.dispatch('getBookCategories')
    },
    getBookChannels() {
      return new Promise((resolve, reject) => {
        this.$http.getBookChannels().then((res) => {
          this.channelsData = res.data.rows
          resolve('ok')
        })
      })
    },
    listSearchEvn(val) {
      if (val) {
        this.params.text = val
      } else {
        delete this.params.text
      }
      this.getCategoriesDetail()
    },
    tableHandle(item) {
      let id = item.data.row.source_type === 4 ? 'ebook_id' : 'id'
      this.$router.push({
        name: 'bookDetails',
        query: {
          id: item.data.row[id],
          source: item.data.row.source_type,
          idTab: this.$route.query.id
        }
      })
    },
    editBook(item) {
      let id = item.source_type === 4 ? 'ebook_id' : 'id'
      this.$router.push({ name: 'addBooks', query: { bookId: item[id] } })
    },
    ediTableHandle(item) {
      let id = item.data.row.source_type === 4 ? 'ebook_id' : 'id'
      this.$router.push({
        name: 'addBooks',
        query: { bookId: item.data.row[id] }
      })
    },
    getPageNum(val) {
      this.params.offset = (val - 1) * this.params.limit
      this.getCategoriesDetail()
    },
    editModules(data) {
      this.$http
        .editBooks(this.$route.query.id, data)
        .then((res) => {
          this.elMsg(this.$t('alertMsg.modifySuccess'), 'success')
          this.getCategoriesDetail()
          this.getBookCategories()
          this.$store.commit('windowHandle')
        })
        .catch((err) => {
          this.elMsg('修改失败', 'error')
          this.$store.commit('windowHandle')
        })
    },
    editBookStack() {
      this.addPopupTitle = this.$t('content.books.editClassify')
      this.$store.commit('windowHandle', 'showClassifyEdit')
    },
    clearSearch() {},
    checkBookDetail(item) {
      let id = item.source_type === 4 ? 'ebook_id' : 'id'
      this.$router.push({
        name: 'bookDetails',
        query: { id: item[id], source: item.source_type }
      })
    },

    async batchAdd() {
      this.listData = this.categories
      this.getArrID()
      if (!this.bookArrId.length && !this.selectDatas.length) {
        this.elMsg(this.$t('alertMsg.checkBook'), 'warning')
        return
      }
      this.bookListTitle = this.$t('content.books.selectGroup')
      this.listData = []
      this.listData = this.channelsData
      this.$store.commit('windowHandle', 'showAddBookList')

      this.emptyPitch()
    },
    moveBook() {
      this.getArrID()
      if (!this.bookArrId.length && !this.selectDatas.length) {
        this.elMsg(this.$t('alertMsg.checkBook'), 'warning')
        return
      }
      this.bookListTitle = this.$t('content.books.selectClassify')
      this.listData = []
      this.listData = this.categories
      this.$store.commit('windowHandle', 'showAddBookList')

      this.emptyPitch()
    },

    async setPriceForBooks() {
      this.getArrID()
      if (!this.bookArrId.length && !this.selectDatas.length) {
        this.elMsg(this.$t('alertMsg.checkBook'), 'warning')
        return
      }
      try {
        let res = await this.$prompt('', this.$t('content.books.setPrice'), {
          confirmButtonText: this.$t('commonMsg.confirm'),
          cancelButtonText: this.$t('commonMsg.cancel'),
          inputPattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/,
          inputErrorMessage: this.$t('verify.num')
        })
        await this.$http.setBooksPrice({
          ids: this.bookArrId.length ? this.bookArrId : this.selectDatas,
          price: res.value
        })
        this.getCategoriesDetail()
        this.clearCheckOpts()
        this.cancel()
        this.elMsg(this.$t('alertMsg.modifySuccess'), 'success')
      } catch (error) {}
    },

    filterEvn(data) {
      let { obj, key } = data
      if (key === 'status') {
        if (!obj[key].length || obj[key].length === 2) {
          delete this.params.status
        } else {
          this.params.status = obj[key][0]
        }
      }

      this.getCategoriesDetail()
    },

    selectEvnTable(val) {
      this.selectDatas = val
    },
    emptyPitch() {
      this.checkAll()
      this.judgeCheckAll()
    },
    batchUpload() {
      this.$store.commit('windowHandle', 'showBatchUpload')
    },
    manageBook(val, isHandle) {
      if (this.$store.state.selectShow) {
      } else {
        this.isSelect = val
        this.isHandle = isHandle
        this.isSelectOverall = true
        this.manage = !this.manage
        if (this.manage) return
        this.clearCheckOpts()
      }
    },
    moduleAddBooks(id) {
      return new Promise((resolve, reject) => {
        let obj = {
          source_type: this.sourceType || 0
        }
        if (this.sourceType === 4) {
          obj.ebook_id = this.bookArrId.length
            ? this.bookArrId
            : this.selectDatas
        } else {
          obj.ids = this.bookArrId.length ? this.bookArrId : this.selectDatas
        }
        this.$http
          .moduleAddBooks(id, obj)
          .then(async (res) => {
            this.elMsg(this.$t('alertMsg.addSuccess'), 'success')
            this.isSelect = false
            this.clearCheckOpts()
            await this.getCategoriesDetail()
            this.bookArrId = []
            this.selectDatas = []
            //                        恢复样式
            this.cancel()
            resolve('')
          })
          .catch((err) => {
            this.elMsg(this.$t('alertMsg.addFailure'), 'error')
            reject(err)
          })
      })
      this.bookArrId = ''
      this.selectDatas = ''
    },
    //        移动分类
    categoriesAddBook(id) {
      let ids = this.bookArrId.length ? this.bookArrId : this.selectDatas
      this.$http
        .categoriesAddBook(id, { ids: ids })
        .then((res) => {
          this.elMsg(this.$t('alertMsg.moveSuccess'), 'success')
          this.getCategoriesDetail()
          this.clearCheckOpts()
          //                        恢复样式
          this.cancel()
        })
        .catch((err) => {
          this.elMsg(this.$t('alertMsg.moveFailure'), 'error')
        })
      this.bookArrId = ''
      this.selectDatas = ''
    },

    async setStatusForBooks(status) {
      this.getArrID()
      if (!this.bookArrId.length && !this.selectDatas.length) {
        this.elMsg(this.$t('alertMsg.checkBook'), 'warning')
        return
      }

      try {
        let ids = this.bookArrId.length ? this.bookArrId : this.selectDatas
        let params = {
          ids,
          status
        }
        console.log(params)
        await this.$http.updateStackBooks(params)
        this.elMsg(this.$t('alertMsg.modifySuccess'), 'success')
        this.getCategoriesDetail()
        this.clearCheckOpts()
        //                        恢复样式
        this.cancel()
      } catch (error) {
        console.log(error)
        this.elMsg(this.$t('alertMsg.modifyFailure'), 'error')
        //                        恢复样式
        this.cancel()
      }
    },
    oddBook() {
      this.getArrID()
      if (!this.bookArrId.length && !this.selectDatas.length) {
        this.elMsg(this.$t('alertMsg.checkBook'), 'warning')
        return
      } else {
        this.delType = 'book'
        this.$store.commit('windowHandle', 'delPopup')
      }
    },

    deleteBook() {
      let ids = this.bookArrId.length ? this.bookArrId : this.selectDatas
      this.$http
        .moduleOutBooks(this.$route.query.id, { ids: ids })
        .then(async (res) => {
          this.elMsg(this.$t('alertMsg.delSuccess'), 'success')
          await this.getCategoriesDetail()
          this.clearCheckOpts()
          this.cancel()
        })
        .catch((err) => {
          this.elMsg('删除失败', 'error')
        })
    },
    clearCheckOpts(val) {
      this.allCheck = false
      this.manage = false
      this.bookArr = []
      this.bookArrId = []
      for (let item of this.booksData) {
        item.checked = false
      }
    },
    confirmEvn(group) {
      if (this.handle === 'batchAddBook') {
        this.cateId = group.id.toString()
        this.$nextTick(() => {
          this.$store.commit('windowHandle', 'showBatchUpload')
        })
        return
        if (group.hasOwnProperty('module_type')) {
          this.moduleAddBooks(group.id)
        } else {
          this.categoriesAddBook(group.id)
        }
      }
      if (group.hasOwnProperty('module_type')) {
        this.moduleAddBooks(group.id)
      } else {
        this.categoriesAddBook(group.id)
      }
    },

    checkOptions(data) {
      if (!this.bookArr.length) {
        for (let item of data.books) {
          item.checked = false
        }
      } else {
        this.getArrID()
        for (let item of data.books) {
          item.checked =
            this.sourceType === 4
              ? this.bookArrId.includes(item.ebook_id)
              : this.bookArrId.includes(item.id)
        }
      }
      this.booksData = data.books
      this.total = data.booksTotal
      this.judgeCheckAll()
    },
    getArrID() {
      this.bookArrId = []
      this.bookArrId = this.bookArr.map((item) => {
        return this.sourceType === 4 ? item.ebook_id : item.id
      })
    },
    selectEvn(book) {
      if (book.checked) {
        this.bookArr = [...this.bookArr, book]
      } else {
        this.bookArr = this.bookArr.filter((item) => {
          return this.sourceType === 4
            ? item.ebook_id !== book.ebook_id
            : item.id !== book.id
        })
      }
      this.judgeCheckAll()
    },
    checkAll(value) {
      if (value) {
        for (let item of this.booksData) {
          item.checked = true
        }
      } else {
        for (let item of this.booksData) {
          item.checked = false
        }
      }
      this.checkAllEvent()
    },
    checkAllEvent() {
      let type = this.sourceType === 4 ? 'ebook_id' : 'id'
      let data = this.booksData
      let ids = this.bookArr.map((item) => item[type])
      for (let i = 0; i < data.length; i++) {
        if (data[i].checked && !ids.includes(data[i][type])) {
          this.bookArr = [...this.bookArr, data[i]]
        } else if (!data[i].checked && ids.includes(data[i][type])) {
          this.bookArr = this.bookArr.filter((item) => {
            return item[type] !== data[i][type]
          })
        }
      }
    },
    judgeCheckAll() {
      if (!this.booksData.length) {
        this.allCheck = false
        return
      }
      let length = 0
      for (let item of this.booksData) {
        if (item.checked) {
          length++
        }
      }
      this.allCheck = this.booksData.length === length
    },
    choseprofrom(id) {
      this.flag = id
    },
    resetView() {
      this.$store.dispatch('setSelectShow', false)
      this.$store.dispatch('setOverallShow', false)
      this.$store.dispatch('setHandleShow', ' ')
      this.isSearch = false
      this.isHandle = ''
      this.isSelectOverall = false
      this.cancel()
      this.bookInfo = {}
      this.booksData = []
    }
  },
  watch: {
    $route(news, olds) {
      if (!news.query.id) {
        this.resetView()
      } else if (news.query.id !== olds.query.id) {
        this.params.offset = 0
      }
      this.$refs.listSearch.clearValue()
      this.getCategoriesDetail()
    },
    showBatchUpload(val) {
      if (!val) {
        this.handle = ''
        this.getCategoriesDetail()
      }
    }
  },
  async mounted() {
    await this.getBookCategories()
    this.getCategoriesDetail()
    await this.getBookChannels()
  }
}
</script>

<style lang="scss">
.stack-container {
  flex: 1;
  display: flex;
  padding: 20px;
  overflow: hidden;
  .stack-card {
    display: flex;
    flex: 1;
    > .el-card__body {
      flex: 1;
      display: flex;
      overflow: hidden;
      .stack-card-left {
        /* overflow: hidden; */
        padding: 10px 0 0 10px;
        width: 250px;
        height: calc(100% - 20px);
        display: flex;
        border-right: 1px solid #ccc;
        flex-direction: column;
        .stack-card-left-header {
          margin-right: 10px;
          padding: 0 5px 5px;
          border-bottom: 1px solid #ccc;
          .stack-card-left-header-title {
            display: flex;
            /* cursor: pointer; */
            justify-content: space-between;
            padding: 5px;
            border-radius: 2px;
            transition: all 0.2s linear;
          }
          .activeTab {
            background: $globalBGColor;
            color: #fff;
          }
        }
        .stack-sideBar-tree-btn {
          padding: 10px;
          > button {
            width: calc(100% - 10px);
            margin-left: 0;
          }
        }
        .stack-sideBar-node {
          width: 250px;
          height: 100%;
          overflow: hidden;
          .stack-sideBar-node-wrap {
            height: 100%;
            overflow: auto;
            padding-right: 0 !important;
          }
        }
      }
      .stack-card-right {
        flex: 1;
        display: flex;
        overflow: hidden;
        flex-direction: column;
        /* padding:10px; */
        .isSearch {
          padding: 20px;
          .searchScl {
            display: flex;
            justify-content: space-between;
          }
        }
        .stack-card-main {
          flex: 1;
          display: flex;
          overflow: hidden;
          flex-direction: column;
          /*二级控制条样式*/
          > .stack-mgt-handle {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
            > .stack-mgt-search {
              display: flex;
              > i {
                margin-right: 10px;
              }
            }
          }
          .stack-mgt-batchBtn {
            text-align: right;
            padding: 0 10px 10px;
          }
          /*内容*/
          > .stack-card-item {
            flex: 1;
            display: flex;
            overflow: hidden;
            flex-direction: column;
            /*切换样式*/
            > .stack-card-sort {
              > .sort-item:first-child {
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                height: 42px;
                padding: 0 20px;
                background: #f3f3f3;
                border-bottom: 1px solid #ccc;
                span {
                  margin-right: 40px;
                  font-weight: 400;
                  font-style: normal;
                  font-size: 12px;
                  color: #666666;
                }
                span.secectBackground {
                  color: #bf735b;
                }
              }
              .sort-item:last-child {
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                height: 42px;
                padding: 0 20px;
                background: #f3f3f3;
                span:first-child {
                  margin-right: 0;
                }
                span {
                  margin-right: 40px;
                  font-weight: 400;
                  font-style: normal;
                  font-size: 12px;
                  color: #666666;
                }
              }
            }
          }

          /*分页*/
        }
      }
    }
  }
}
</style>
